/* eslint-disable no-nested-ternary */
import type { IIndicatorFieldsFragment } from "components/financials/modern/graphql/fragments/__generated__/IndicatorFieldsFragment.generated";
import useTheme from "components/ui/useTheme";
import tinycolor from "tinycolor2";

interface IndicatorCategoryDotProps {
  indicator: Pick<IIndicatorFieldsFragment, "columnTheme">;
}
export default function IndicatorCategoryDot({ indicator }: IndicatorCategoryDotProps) {
  const theme = useTheme();
  const isDarkTheme = theme === "dark";
  return (
    <span
      aria-hidden={true}
      className="inline-flex h-3 w-3 items-center justify-center rounded-full"
      style={{
        backgroundColor: isDarkTheme
          ? tinycolor(indicator.columnTheme.backgroundColor).darken(30).setAlpha(0.8).toRgbString()
          : tinycolor(indicator.columnTheme.backgroundColor).setAlpha(1).toRgbString(),
      }}
    >
      <span
        className="h-2 w-2 rounded-full"
        style={{
          backgroundColor: isDarkTheme
            ? tinycolor(indicator.columnTheme.textColor).setAlpha(0).toRgbString()
            : tinycolor(indicator.columnTheme.textColor).setAlpha(0.7).toRgbString(),
        }}
      />
    </span>
  );
}
